import { render, staticRenderFns } from "./VaDivider.vue?vue&type=template&id=c2e64a3e&scoped=true&"
import script from "./VaDivider.vue?vue&type=script&lang=ts&"
export * from "./VaDivider.vue?vue&type=script&lang=ts&"
import style0 from "./VaDivider.vue?vue&type=style&index=0&id=c2e64a3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e64a3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2e64a3e')) {
      api.createRecord('c2e64a3e', component.options)
    } else {
      api.reload('c2e64a3e', component.options)
    }
    module.hot.accept("./VaDivider.vue?vue&type=template&id=c2e64a3e&scoped=true&", function () {
      api.rerender('c2e64a3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/VaDivider.vue"
export default component.exports